import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Toastr
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

// Flatpickr
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

// Select2
import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.min.css'

window.$ = window.jQuery = $

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

const app = createApp(App)
const pinia = createPinia()
app.use(router)
app.use(store)
app.use(pinia)
app.component('font-awesome-icon', FontAwesomeIcon)
app.config.globalProperties.$toastr = toastr
app.config.globalProperties.$flatpickr = flatpickr
app.mount('#app')
